 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLMINI_TOC from '@/components/xhtml/mini_toc'
 import XHTMLCOPYRIGHTNOTICE from '@/components/xhtml/copyrightnotice'
 import XHTMLDEDICATION from '@/components/xhtml/dedication'
 import XHTMLACKNOWLEDGMENTS from '@/components/xhtml/acknowledgments'
 import XHTMLPRECLUDE from '@/components/xhtml/preclude'
 import XHTMLCHAPTER1 from '@/components/xhtml/chapter1'
 import XHTMLCHAPTER1A from '@/components/xhtml/chapter1a'
 import XHTMLCHAPTER2 from '@/components/xhtml/chapter2'
 import XHTMLCHAPTER3 from '@/components/xhtml/chapter3'
 import XHTMLCHAPTER3A from '@/components/xhtml/chapter3a'
 import XHTMLCHAPTER4 from '@/components/xhtml/chapter4'
 import XHTMLCHAPTER5 from '@/components/xhtml/chapter5'
 import XHTMLCHAPTER5A from '@/components/xhtml/chapter5a'
 import XHTMLCHAPTER6 from '@/components/xhtml/chapter6'
 import XHTMLCHAPTER7 from '@/components/xhtml/chapter7'
 import XHTMLCHAPTER8 from '@/components/xhtml/chapter8'
 import XHTMLCHAPTER8A from '@/components/xhtml/chapter8a'
 import XHTMLCHAPTER9 from '@/components/xhtml/chapter9'
 import XHTMLCHAPTER10 from '@/components/xhtml/chapter10'
 import XHTMLCHAPTER11 from '@/components/xhtml/chapter11'
 import XHTMLCHAPTER11A from '@/components/xhtml/chapter11a'
 import XHTMLCHAPTER12 from '@/components/xhtml/chapter12'
 import XHTMLCHAPTER13 from '@/components/xhtml/chapter13'
 import XHTMLCHAPTER14 from '@/components/xhtml/chapter14'
 import XHTMLCHAPTER14A from '@/components/xhtml/chapter14a'
 import XHTMLCHAPTER15 from '@/components/xhtml/chapter15'
 import XHTMLCHAPTER16 from '@/components/xhtml/chapter16'
 import XHTMLCHAPTER16A from '@/components/xhtml/chapter16a'
 import XHTMLCHAPTER17 from '@/components/xhtml/chapter17'
 import XHTMLCHAPTER18 from '@/components/xhtml/chapter18'
 import XHTMLCHAPTER18A from '@/components/xhtml/chapter18a'
 import XHTMLCHAPTER19 from '@/components/xhtml/chapter19'
 import XHTMLCHAPTER20 from '@/components/xhtml/chapter20'
 import XHTMLCHAPTER20A from '@/components/xhtml/chapter20a'
 import XHTMLCHAPTER21 from '@/components/xhtml/chapter21'
 import XHTMLCHAPTER22 from '@/components/xhtml/chapter22'
 import XHTMLABOUTTHEAUTHOR from '@/components/xhtml/abouttheauthor'
 import XHTMLADCARD from '@/components/xhtml/adcard'
 import XHTMLNEWSLETTER from '@/components/xhtml/newsletter'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/title",
 			"name" : "xhtml/title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/mini_toc",
 			"name" : "xhtml/mini_toc",
 			"component" : XHTMLMINI_TOC
 		},
 		{
 			"path" : "/xhtml/copyrightnotice",
 			"name" : "xhtml/copyrightnotice",
 			"component" : XHTMLCOPYRIGHTNOTICE
 		},
 		{
 			"path" : "/xhtml/dedication",
 			"name" : "xhtml/dedication",
 			"component" : XHTMLDEDICATION
 		},
 		{
 			"path" : "/xhtml/acknowledgments",
 			"name" : "xhtml/acknowledgments",
 			"component" : XHTMLACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/preclude",
 			"name" : "xhtml/preclude",
 			"component" : XHTMLPRECLUDE
 		},
 		{
 			"path" : "/xhtml/chapter1",
 			"name" : "xhtml/chapter1",
 			"component" : XHTMLCHAPTER1
 		},
 		{
 			"path" : "/xhtml/chapter1a",
 			"name" : "xhtml/chapter1a",
 			"component" : XHTMLCHAPTER1A
 		},
 		{
 			"path" : "/xhtml/chapter2",
 			"name" : "xhtml/chapter2",
 			"component" : XHTMLCHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js